import {
  IconBolt,
  IconBomb,
  IconChevronDown,
  IconCircleDot,
  IconClock,
  IconClover,
  IconDiamond,
  IconDice1,
  IconDice5,
  IconPick,
  IconSpade,
  IconSparkles,
  IconStack2,
  IconTarget,
  IconTicket,
  IconTrophy,
  IconVideo,
} from "@tabler/icons-react";
import PropTypes from "prop-types";
import styles from "./CategoryChip.module.css";

const CATEGORY_ICONS = {
  baccarat: IconStack2,
  blackjack: IconSpade,
  card: IconClover,
  casual: IconSparkles,
  "classic slots": IconDiamond,
  crash: IconBolt,
  dice: IconDice1,
  instant: IconClock,
  "live game": IconVideo,
  lottery: IconTicket,
  mines: IconPick,
  plinko: IconCircleDot,
  roulette: IconTarget,
  scratch: IconBomb,
  slots: IconDice5,
  smash4cash: IconTrophy,
  table: IconChevronDown,
};

const getCategoryIcon = key => {
  const categorySlug = key?.replace("/games/category/", "").toLowerCase();
  return CATEGORY_ICONS[categorySlug] ?? IconSparkles;
};

const CategoryChip = ({category, isActive, onClick}) => {
  const IconComponent = getCategoryIcon(category.key);

  return (
    <div
      className={`${styles.chip} ${isActive ? styles.active : ""}`}
      onClick={onClick}
    >
      <IconComponent
        size={16}
        stroke={2}
        className={styles.chipIcon}
      />
      <span className={styles.chipText}>{category.label}</span>
    </div>
  );
};

CategoryChip.propTypes = {
  category: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CategoryChip;
